import { FC, memo } from 'react';

import clsx from 'clsx';
import { times } from 'lodash';
import { RiErrorWarningLine } from 'react-icons/ri';

import DittoMascot from '@imgs/dittoiconsmall.png';
import { Box, Loader, Text, Button, Group, Stack, Flex } from '@ui';

import classes from './styles/Info.module.css';

interface InfoProps {
  dittoIcon?: boolean;
  dittoIconBig?: boolean;
  info: string | string[];
  type: 'info' | 'pageinfo';
  cta?: string;
  loading?: boolean;
  xsOnly?: boolean;
  onClickCta?: () => void;
}

// todo : check and get rid of this component
const Info: FC<InfoProps> = memo(
  ({ dittoIcon, dittoIconBig, type, info, cta, xsOnly, loading, onClickCta }) => {
    const renderSingleInfo = (infoString: string) => {
      return (
        <Text fz={{ base: 12, sm: 14 }} color="primary">
          {infoString}
        </Text>
      );
    };

    const renderInfoWithIcon = () => {
      if (!Array.isArray(info)) {
        return (
          <Group align="center">
            <Box mr={8} mt={2}>
              <RiErrorWarningLine style={{ color: '#3DABF5', fontSize: 16 }} />
            </Box>
            {renderSingleInfo(info)}
          </Group>
        );
      } else {
        return (
          <Stack w="100%">
            {times(info.length, (index) => {
              return (
                <Group key={index}>
                  <Box mr={8} mt={2}>
                    <RiErrorWarningLine style={{ color: '#3DABF5', fontSize: 16 }} />
                  </Box>
                  {renderSingleInfo(info[index])}
                </Group>
              );
            })}
          </Stack>
        );
      }
    };

    const infoComponent = (
      <Group
        w="100%"
        bg={type === 'info' ? '#F7F9FA' : 'rgba(30, 201, 255,0.10)'}
        justify="space-between"
        align="center"
        style={{ borderRadius: 8 }}
        p={11}
        my={12}
        className={loading ? classes.infoLoading : undefined}
      >
        {dittoIcon ? (
          <Group align="center">
            <Flex
              className={clsx(classes.infoIconContainer, {
                [classes.infoIconBig]: dittoIconBig
              })}
            >
              <img
                src={DittoMascot}
                className={
                  !dittoIconBig ? classes.fieldInfoImg : classes.fieldInfoImgNoMargin
                }
                alt="ditto"
              />
            </Flex>
            {!Array.isArray(info) ? (
              renderSingleInfo(info)
            ) : (
              <>
                {times(info.length, (index) => (
                  <Text key={index} c="primary" fz={{ base: 12, sm: 14 }}>
                    {info[index]}
                  </Text>
                ))}
              </>
            )}
          </Group>
        ) : (
          renderInfoWithIcon()
        )}
        {loading && (
          <Group align="center">
            <Loader color="primary" size={20} mx={10} />
          </Group>
        )}

        {cta && onClickCta && (
          <Button
            variant="text"
            color="primary"
            onClick={onClickCta}
            fullWidth
            size="small"
          >
            {cta}
          </Button>
        )}
      </Group>
    );
    if (xsOnly) {
      return <Box visibleFrom="sm">{infoComponent}</Box>;
    }
    return infoComponent;
  }
);

export { Info };
